import {Component, Input} from '@angular/core';
import {BaseResultComponent} from '../../../base-result/base-result.component';
import {UniversityProject} from '../../../../../class/lifeproject/university-project';
import {NbWindowService} from '@nebular/theme';

@Component({
    selector: 'app-university-view',
    templateUrl: './university-view.component.html',
    styleUrls: ['./university-view.component.css']
})
export class UniversityViewComponent extends BaseResultComponent {

    @Input()
    uniProject: UniversityProject;

    constructor(windowService: NbWindowService) {
        super(windowService);
    }

    onResultImpl(): void {
        super.onResultImpl();
    }
}
